import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";
import React, {FC} from "react";
import NoResultsOverlay from "@/widget/NoResultsOverlay/NoResultsOverlay";

interface ResultWrapperProps {
    isLoading?: boolean;
    children: React.ReactNode;
    isEmpty?: boolean;
}

export const ResultWrapper: FC<ResultWrapperProps> = ({children, isLoading, isEmpty}) => {
    return <Box width={'100%'} minHeight={isEmpty ? 300 : 'auto'} alignContent={'center'} display={'flex'} alignItems={isLoading || isEmpty ? 'center' : 'start'} height={'100%'}
                justifyContent={'center'}>{isLoading ?
        <CircularProgress/> : isEmpty ?
            <NoResultsOverlay kind={'default'}/> : children}</Box>
}